import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';

import authenticationService from 'services/AuthenticationService';
import { useAppMode } from 'contexts/AppModeContext';
import LoginPage from 'pages/LoginPage';
import AuthenticationPage from 'pages/AuthenticationPage';

const LoginRoute = () => {
  const [isUserAuthenticated, setIsUserAuthenticated] = useState(null);
  const { isEmbedded, isTokenReady, error } = useAppMode();

  useEffect(() => {
    // Use unified authentication service
    authenticationService
      .validateUser()
      .then(result => {
        setIsUserAuthenticated(result.isValidUser);
      })
      .catch(() => {
        setIsUserAuthenticated(false);
      });
  }, [isTokenReady]);

  // In embedded mode, redirect to main page if authenticated
  if (isEmbedded) {
    if (isUserAuthenticated === true) return <Navigate to="/health-plans" />;
    if (isUserAuthenticated === false) {
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <p>Waiting for authentication token from parent portal...</p>
          {error && <p style={{ color: 'red' }}>Error: {error}</p>}
        </div>
      );
    }
    return <AuthenticationPage />;
  }

  // Standard mode behavior
  if (isUserAuthenticated === true) return <Navigate to="/health-plans" />;

  if (isUserAuthenticated === false) return <LoginPage />;

  return <AuthenticationPage />;
};

export default LoginRoute;
